"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require('es6-promise').Promise;
var $ = require("jquery");
require("cropper");
var EXIF = require('exif-js');
var cardUploadIndex = /** @class */ (function () {
    function cardUploadIndex() {
        this.cropper();
    }
    cardUploadIndex.getInstance = function () {
        return new cardUploadIndex();
    };
    cardUploadIndex.prototype.cropper = function () {
        var cropperInstance = null, $uploadContainer = $('#upload-container'), $initialImage = $('#upload'), $updateImage = $('#update-image'), $binBtn = $('#bin'), $cropper = $('#cropper'), $rotateBtn = $('.js-rotate'), $uploadBtn = $('.js-upload'), $submitBTn = $('.js-submit'), $termsCheck = $('.js-terms-check'), containerWidth = null, containerHeight = null, landscape = true, currentImage = null, options = {
            viewMode: 3,
            modal: false,
            cropBoxResizable: false,
            cropBoxMovable: false,
            dragMode: 'move',
            toggleDragModeOnDblclick: false,
            background: false,
            checkOrientation: true,
            rotatable: false,
            scalable: false,
            ready: function () {
                // let aspectRatio = landscape ? 872 / 581 : 581 / 872;
                var aspectRatio = landscape ? 1800 / 1200 : 1200 / 1800;
                this.cropper.setAspectRatio(aspectRatio);
                updateCropperContainer(this.cropper);
            },
            zoom: function (event) {
                if (event.detail.ratio > 2) {
                    event.preventDefault();
                    this.cropper.zoomTo(2);
                }
            }
        };
        var $body = $('body');
        $initialImage.on('change', function () {
            initCropper($(this));
        });
        $binBtn.on('click', function (e) {
            e.preventDefault();
            if (window.confirm(STORE.trans.confirmImageUpdate)) {
                $updateImage.trigger('click');
            }
        });
        $updateImage.on('change', function (e) {
            e.stopImmediatePropagation();
            updateImage($(this));
        });
        $rotateBtn.on('click', function () {
            rotateCropper();
        });
        $uploadBtn.on('click', function () {
            $initialImage.trigger('click');
        });
        $termsCheck.on('change', function () {
            if ($(this).is(':checked')) {
                $submitBTn.removeAttr('disabled');
            }
            else {
                $submitBTn.prop('disabled', true);
            }
        });
        $submitBTn.on('click', function (e) {
            e.preventDefault();
            var base64Image = cropperInstance.getCroppedCanvas({
                width: landscape ? 1800 : 1200,
                height: landscape ? 1200 : 1800,
            }).toDataURL('image/jpeg'), url = $(this).data('url');
            // cropperInstance.getCroppedCanvas({
            //         maxWidth: 872,
            //         maxHeight: 872,
            //     }).toBlob(function (blob) {
            //     let formData = new FormData();
            //     formData.append('croppedImage', blob);
            //     console.log(formData.get('croppedImage'));
            // });
            if (!landscape) {
                getRotatedBase64Image(base64Image).then(function (rotatedBase64Image) {
                    saveImage(url, rotatedBase64Image);
                });
            }
            else {
                saveImage(url, base64Image);
            }
        });
        function initCropper($input) {
            var $image = null;
            containerWidth = $uploadContainer.outerWidth();
            containerHeight = $uploadContainer.outerHeight();
            getImageBase64String($input).then(function (base64String) {
                loadImage(base64String).then(function (image) {
                    currentImage = image.src;
                    $image = $(image);
                    $cropper.append($image);
                    setCropContainerDimensions(image.width, image.height, getImageOrientation(image));
                    $image.cropper(options);
                    cropperInstance = $image.data('cropper');
                    $input.parent().remove();
                    $body.addClass('img-selected');
                });
            });
        }
        function updateCropperContainer(cropper) {
            var canvasWidth = cropper.getCanvasData().width;
            if (canvasWidth < containerWidth) {
                cropper.setCanvasData({
                    top: 0,
                    left: 0,
                    width: containerWidth
                });
            }
            else {
                cropper.setCanvasData({
                    top: 0,
                    left: 0,
                    height: containerHeight,
                });
            }
            setCropBox(cropper, cropper.getContainerData());
        }
        function rotateCropper() {
            if (landscape) {
                setCropContainerDimensions(0, 1);
                cropperInstance.replace(currentImage);
            }
            else {
                setCropContainerDimensions(1, 0);
                cropperInstance.replace(currentImage);
            }
        }
        function setCropContainerDimensions(width, height, orientation) {
            if (orientation === void 0) { orientation = null; }
            if (width < height || orientation === 6 || orientation === 8) {
                $cropper.css({ maxWidth: '400px', maxHeight: '600px' });
                $cropper.width(containerHeight);
                $cropper.height(containerWidth);
                landscape = false;
            }
            else {
                $cropper.css({ maxWidth: '872px', maxHeight: '581px' });
                $cropper.width(containerWidth);
                $cropper.height(containerHeight);
                landscape = true;
            }
        }
        function setCropBox(cropper, containerData) {
            cropper.setCropBoxData({
                left: 0,
                top: 0,
                width: containerData.width,
                height: containerData.height
            });
        }
        function updateImage($input) {
            getImageBase64String($input).then(function (base64String) {
                loadImage(base64String).then(function (image) {
                    currentImage = image.src;
                    setCropContainerDimensions(image.width, image.height, getImageOrientation(image));
                    cropperInstance.replace(currentImage);
                });
            });
        }
        function loadImage(src) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.src = src;
                img.onload = function () {
                    //Resize img before passing it to cropper
                    // if (img.width > 872 || img.height > 872) {
                    if (img.width > 1800 || img.height > 1800) {
                        var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d"), factor = void 0;
                        // img.width > img.height ? factor = img.width / 872 : factor = img.height / 872;
                        img.width > img.height ? factor = img.width / 1800 : factor = img.height / 1800;
                        canvas.width = img.width / factor;
                        canvas.height = img.height / factor;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        img.src = canvas.toDataURL();
                    }
                    resolve(img);
                };
            });
        }
        function getImageBase64String($input) {
            return new Promise(function (resolve, reject) {
                if ($input[0].files && $input[0].files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (e) { return resolve(e.target.result); };
                    reader.readAsDataURL($input[0].files[0]);
                }
                else {
                    reject('error');
                }
            });
        }
        function getRotatedBase64Image(src) {
            return new Promise(function (resolve, reject) {
                var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
                loadImage(src).then(function (image) {
                    canvas.width = image.height;
                    canvas.height = image.width;
                    ctx.rotate(90 * Math.PI / 180);
                    ctx.translate(0, -canvas.width);
                    ctx.drawImage(image, 0, 0);
                    resolve(canvas.toDataURL());
                });
            });
        }
        function saveImage(url, base64Image) {
            //For debugging
            //$('.upload').append('<img src="'+base64Image+'"/>');
            $.ajax(url, {
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                method: 'POST',
                dataType: 'JSON',
                data: {
                    custom_card: base64Image
                },
                success: function (response) {
                    window.location.replace(response.redirectUrl);
                },
                error: function () {
                    console.log('Error');
                }
            });
        }
        function getImageOrientation(image) {
            var orientation = null;
            EXIF.getData(image, function () {
                orientation = EXIF.getTag(image, 'Orientation');
            });
            return orientation;
        }
    };
    return cardUploadIndex;
}());
exports.default = cardUploadIndex;
